// Общото на Excel експортите в склада (`utils/excelExport` сваля файла; тук е
// само как изглеждат клетките). Парите — число с 2 знака: сбор от float-ове
// иначе излиза 12.300000000000001. Редовете „Общо" в експортите следват реда
// „Общо" на таблицата — същите суми, същите изключения (анулираните не влизат).
export const excelMoney = (value: number | null | undefined) => Number((value || 0).toFixed(2));
